import * as Sentry from '@sentry/browser';

export const swiper = (swiper: HTMLElement) => {

  // Elementy
  const swiperContainer: HTMLElement | null = swiper.querySelector('[data-swiper-container]');
  const swiperItems: HTMLElement | null = swiper.querySelector('[data-swiper-items]');
  const arrowLeft: HTMLElement | null = swiper.querySelector('[data-swiper-arrow-left]');
  const arrowRight: HTMLElement | null = swiper.querySelector('[data-swiper-arrow-right]');
  const arrowGradientRight: HTMLElement | null = swiper.querySelector(
    '.swiper__arrow-gradient--right'
  );
  const arrowGradientLeft: HTMLElement | null = swiper.querySelector(
    '.swiper__arrow-gradient--left'
  );

  if (
    !swiperContainer ||
    !swiperItems ||
    !arrowLeft ||
    !arrowRight ||
    !arrowGradientRight ||
    !arrowGradientLeft
  ) {
    Sentry.captureException('navigation: Chybí některý z elementů navigace');
    return;
  }

  // Aktualizovat šipky
  const updateArrows = () => {
    const containerWidth = swiperContainer.offsetWidth;
    const contentWidth = swiperItems.scrollWidth;
    const scrollLeft = swiperContainer.scrollLeft;
    const scrollRight = contentWidth - scrollLeft - containerWidth;

    // Levá šipka
    if (scrollLeft > 0) {
      arrowLeft.style.display = 'block';
      arrowGradientLeft.style.display = 'block';
    } else {
      arrowLeft.style.display = 'none';
      arrowGradientLeft.style.display = 'none';
    }

    // Pravá šipka
    if (scrollLeft + containerWidth < contentWidth) {
      arrowRight.style.display = 'block';
      arrowGradientRight.style.display = 'block';
    } else {
      arrowRight.style.display = 'none';
      arrowGradientRight.style.display = 'none';
    }

    // Pokud není potřeba, skrýt pravou šipku
    if (contentWidth <= containerWidth) {
      arrowRight.style.display = 'none';
      arrowGradientRight.style.display = 'none';
    }

    // Zcela na pravém okraji (20px je "rezervní vůle" pro padding)
    if (scrollRight < 20) {
      // Skrýt pravou šipku
      arrowRight.style.display = 'none';
      arrowGradientRight.style.display = 'none';
    }
  };

  // Scroll vpravo/vlevo
  const scrollSwiper = (direction: 'left' | 'right') => {
    const containerWidth = swiperContainer.offsetWidth;
    const scrollAmount = direction === 'left' ? -containerWidth : containerWidth;

    swiperContainer.setAttribute('scrolled', '0');
    swiperContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  arrowRight.addEventListener('click', () => scrollSwiper('right'));
  arrowLeft.addEventListener('click', () => scrollSwiper('left'));

  updateArrows();
  swiperContainer.addEventListener('scroll', updateArrows);
};
